import {
  GET_FRIENDS,
  GET_USER_FRIENDS,
  GET_PENDING_FRIENDS,
  SEND_USER_REQUEST,
  SEND_BUSINESS_CASUAL_REQUEST,
  FOLLOW_USER,
  ADD_FRIEND,
  REMOVE_APPROVAL_REQUEST,
  REMOVE_FRIEND,
  FRIEND_ERROR,
  CLEAR_FRIENDS,
} from "../actions/types";

const initialState = {
  friends: {},
  friend: {},
  userfriends: {},
  userfriend: {},
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FRIENDS:
      return {
        ...state,
        friends: payload,
        loading: false,
      };
    case GET_USER_FRIENDS:
      return {
        ...state,
        userfriends: payload,
        loading: false,
      };
    case REMOVE_FRIEND:
      return {
        ...state,
        friends: payload,
        loading: false,
      };
    case SEND_USER_REQUEST:
      return {
        ...state,
        friends: payload,
        loading: false,
      };
    case REMOVE_APPROVAL_REQUEST:
      return {
        ...state,
        friends: payload,
        loading: false,
      };
    case ADD_FRIEND:
    case FOLLOW_USER:
      return {
        ...state,
        friends: payload,
        loading: false,
      };
    case FRIEND_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_FRIENDS:
      return {
        ...state,
        friend: {},
        friends: {},
        loading: false,
      };
    default:
      return state;
  }
}
